import BaseAPI from "../baseAPI"

class ContentMAPI extends BaseAPI {
  getEmployees() {
    return this.get("/ohanas")
  }

  getPresses(query) {
    return this.getByQuery("/presses", query)
  }

  getGalleries() {
    return this.get("/galleries")
  }

  getPhilanthropy() {
    return this.get("/philanthropy")
  }

  getPhilanthropyGalleries(id, query) {
    return this.getByQuery(`/philanthropy/${id}/galleries`, query)
  }

  getCulturalEvs(query) {
    return this.getByQuery("/cultural-events", query)
  }

  getCulturalEvDetails(param) {
    return this.get(`/cultural-events/${param}`)
  }

  getCulturalEvRecoms(param) {
    return this.get(`/cultural-events/${param}/recommendation`)
  }

  getTourGuides(query) {
    return this.getByQuery("/tour-guides", query, true)
  }

  getTourGuideDetails(param) {
    return this.get(`/tour-guides/${param}`, true)
  }

  getTourGuideRecoms(param) {
    return this.get(`/tour-guides/${param}/recommendation`, true)
  }

  getBlogs(query) {
    return this.getByQuery("/blogs", query, true)
  }

  getBlogDetails(param) {
    return this.get(`/blogs/${param}`, true)
  }

  getBlogRecoms(param) {
    return this.get(`/blogs/${param}/recommendation`, true)
  }
}

export { ContentMAPI as default }